import { render, staticRenderFns } from "./DeliveryNoticeLabel.vue?vue&type=template&id=ac358e2e&scoped=true&"
import script from "./DeliveryNoticeLabel.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoticeLabel.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNoticeLabel.vue?vue&type=style&index=0&id=ac358e2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac358e2e",
  null
  
)

export default component.exports